
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("cbo1b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "checkForIncidentTargetingCohorts", () => $a395ecfb41da7104$export$bd99aa80e21794c8);
$parcel$export(module.exports, "default", () => $a395ecfb41da7104$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");

var $jGzN3 = parcelRequire("jGzN3");
const $a395ecfb41da7104$var$fetchSiteUserPersonalization = ()=>(0, $jGzN3.performGetRequest)('/rest/incidents/tap/site-user-traits');
const $a395ecfb41da7104$export$bd99aa80e21794c8 = async (environment)=>{
    const JIRA_SOFTWARE_IS_INCIDENTS_AUDIENCE_COHORT_1 = environment === 'prod' ? 'segment_1680cb73-5c78-4932-8e89-2e8e982c74e5_siteuser' : 'segment_97aabc97-1b14-49b9-afa5-a8501c704029_siteuser';
    const JIRA_SOFTWARE_IS_INCIDENTS_AUDIENCE_COHORT_2 = environment === 'prod' ? 'segment_05b92485-f868-4f1e-b168-ca5a9d5a4e84_siteuser' : 'segment_fbfbdefc-2e71-4597-9f21-b3133a7da2fb_siteuser';
    const personalizationData = await $a395ecfb41da7104$var$fetchSiteUserPersonalization();
    if ((0, $7jTnu.fg)('operandi-incidents-in-jira-skip-targeting')) return {
        cohort1: true,
        cohort2: true
    };
    if (!personalizationData) return {
        cohort1: false,
        cohort2: false
    };
    const isUserInAudience = {
        cohort1: personalizationData[JIRA_SOFTWARE_IS_INCIDENTS_AUDIENCE_COHORT_1] === true,
        cohort2: personalizationData[JIRA_SOFTWARE_IS_INCIDENTS_AUDIENCE_COHORT_2] === true
    };
    return isUserInAudience;
};
const $a395ecfb41da7104$var$getData = async (_route, // eslint-disable-next-line @typescript-eslint/no-explicit-any
{ tenantContext: { environment: environment } })=>$a395ecfb41da7104$export$bd99aa80e21794c8(environment);
var $a395ecfb41da7104$export$2e2bcd8739ae039 = $a395ecfb41da7104$var$getData;

});


//# sourceMappingURL=async-resource-incident-experiment-traits.2b90f82e.js.map
